<div id="popover-content">
  <ng-container *ngIf="phenotype$ | ngrxPush as p">
    <nz-card
      [nzTitle]="cardTitle"
      nzBordered="false"
      id="card-content"
      [nzExtra]="linkout">
      <ng-template #cardTitle>
        <i
          nz-icon
          nzType="civic-phenotype"
          nzTheme="twotone"
          nzTwotoneColor="#2A63B6"></i>
        {{ p.name }}
      </ng-template>
      <ng-template #linkout>
        <cvc-link-tag
          [href]="p.url"
          tooltip="View in the Human Phenotype Ontology">
          {{ p.hpoId }}
        </cvc-link-tag>
      </ng-template>

      <nz-descriptions
        nzSize="small"
        [nzColumn]="2"
        nzBordered="true">
        <nz-descriptions-item
          nzTitle="Assertions"
          nzSpan="2">
          {{ p.assertionCount }}
        </nz-descriptions-item>
        <nz-descriptions-item
          nzTitle="Evidence"
          nzSpan="2">
          {{ p.evidenceItemCount }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Molecular Profiles"
          nzSpan="2">
          {{p.molecularProfileCount}}
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-card>
  </ng-container>
</div>
